import MedicineList from '@/views/Medicine/MedicineList'
import MedicineAdd from '@/views/Medicine/MedicineFormAddEdit'
import MedicineEdit from '@/views/Medicine/MedicineFormAddEdit'
import MedicineDetail from '@/views/Medicine/MedicineDetail'

const medicine = [
  {
    path: 'medicines',
    name: 'MedicineList',
    component: MedicineList
  },
  {
    path: 'medicines/add',
    name: 'MedicineAdd',
    component: MedicineAdd,
    props: true
  },
  {
    path: 'medicines/:id/edit',
    name: 'MedicineEdit',
    component: MedicineEdit
  },
  {
    path: 'medicines/:id',
    name: 'MedicineDetail',
    component: MedicineDetail,
    props: true
  },
];

export default medicine;



// WEBPACK FOOTER //
// ./src/router/modules/medicine.js